var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g({staticClass:"base-btn__form text-center tracking-wide rounded-full px-3 sm:px-6 transition-all ease-out",attrs:{"disabled":_setup.isDisabled,"form":_vm.form}},_vm.$listeners),[_c('span',{staticClass:"h-12 whitespace-nowrap flex items-center justify-center space-x-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }